import { render, staticRenderFns } from "./ViewBranch.vue?vue&type=template&id=3dc64648&scoped=true"
import script from "./ViewBranch.vue?vue&type=script&lang=js"
export * from "./ViewBranch.vue?vue&type=script&lang=js"
import style0 from "./ViewBranch.vue?vue&type=style&index=0&id=3dc64648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc64648",
  null
  
)

export default component.exports